// extracted by mini-css-extract-plugin
export default {"privacyNotice":"privacyNotice_privacyNotice__KSGf8"};